import React, { useEffect } from "react";
import { appRoutes } from "../../../routes/routes";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import { isMobile } from "react-device-detect";

let reTry: number = 0;

const NODE_ENV = process.env.NODE_ENV;

const BoardingScreen = () => {
  const getCodeAlert = () => {
    let code = window.prompt("Enter company code:");
    if (code) {
      code = code.trim();
      const newRouteName = UtilityHelper.getLastArrayStringValue(
        appRoutes.routeNameSplash
      );
      window.location.replace(`/${code}/${newRouteName}`);
    } else {
      reTry++;

      if (reTry <= 4) {
        getCodeAlert();
      }
    }
  };

  useEffect(() => {
    if (NODE_ENV === "development") {
      getCodeAlert();
    } else {
      if (isMobile) {
        if (UtilityHelper.checkStandAlone()) {
          getCodeAlert();
        } else {
          UtilityHelper.redirectToSite();
        }
      } else {
        UtilityHelper.redirectToSite();
      }
    }
    // eslint-disable-next-line
  }, []);

  return <></>;
};

export default BoardingScreen;
export const routeName: string = "/";
